import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {LeafletCoordinate} from '../../types/thirdparty';
import {DeliveryType} from '../../types/enums';
import {GeoLocation} from '../../types/interfaces';

@Component({
  selector: 'app-delivery-area-location-modal',
  templateUrl: './delivery-area-location-modal.page.html',
  styleUrls: ['./delivery-area-location-modal.page.scss'],
})
export class DeliveryAreaLocationModalPage implements OnInit {

  @Input() Location: GeoLocation;
  @Input() MatchedArea: { coordinate: LeafletCoordinate; options: any, styleName: string, deliveryType: DeliveryType };
  @Input() Areas: { coordinate: LeafletCoordinate; options: any, styleName: string, deliveryType: DeliveryType }[] = [];

  centerCoordinate: LeafletCoordinate;
  mapAreas: { coordinate: LeafletCoordinate; options: any, styleName: string, deliveryType: DeliveryType }[];
  markers: { coordinate: LeafletCoordinate; styleName: string; title?: string }[];
  zoom: number;
  isInDeliveryArea: boolean;

  constructor(
    private modalController: ModalController
  ) {
  }

  ngOnInit() {
    this.isInDeliveryArea = !!this.MatchedArea;
    this.centerCoordinate = {
      lat: Number(this.Location.Latitude),
      lng: Number(this.Location.Longitude)
    };
    this.markers = [{
      coordinate: this.centerCoordinate,
      styleName: 'solid',
      title: 'Dein Standort'
    }];
    if (this.isInDeliveryArea) {
      this.mapAreas = [this.MatchedArea];
      this.zoom = 13;
    } else {
      this.mapAreas = (this.Areas || []).map(area => Object.assign({}, area, {styleName: 'notSelected'}));
      this.zoom = 11;
    }
  }

  closeModal() {
    return this.modalController.dismiss();
  }
}
